
const constants = {}

//  审核状态 0/审核不通过,1/草稿,2/待审核,3/审核通过
constants.roleApprovalState = {
  Reject: 0,
  Draft: 1,
  Review: 2,
  Pass: 3
}

// 1每日登录/2每日签到/3每日投递可回收物/4每日阅读咨询/5所有用户每周排行前10名/6社区每周排名前10/7完善个人资料/8自提兑换商品/9取消兑换自提商品/10后台授予/11线下投递可回收物给到积分/12自提兑换商品/13线上投递可回收物给到积分/14取消兑换售货机商品/15售货机订单上报异常处理返还/16积分过期/17扣除积分/18投递其他物品给到积分/19代投递可回收物/20代投递其他物品/21代换商品
constants.integralType = {
  1: '每日登录',
  2: '每日签到',
  3: '每日投递可回收物',
  4: '每日阅读咨询',
  5: '所有用户每周排行前10名',
  6: '社区每周排名前10',
  7: '完善个人资料',
  8: '自提兑换商品',
  9: '取消兑换自提商品',
  10: '后台授予',
  11: '线下投递可回收物给到积分',
  12: '售货柜兑换商品',
  13: '线上投递可回收物给到积分',
  14: '取消兑换售货机商品',
  15: '售货机订单上报异常处理返还',
  16: '积分过期',
  17: '扣除积分',
  18: '投递其他物品给到积分',
  19: '代投递可回收物',
  20: '代投递其他物品',
  21: '代换商品',
  22: '积分抵扣物业费',
  23: '赠送积分',
  24: '被赠送积分'
}
export default constants
